import React from 'react'
import classNames from 'classnames'
import { Checkbox, Button } from '@scentregroup/ui'
import PropTypes from 'prop-types'
import SortDropdown from '../sort-dropdown'
import style from './index.module.scss'

const NUMBER_OF_PRODUCT_CARDS = 3
const FULL_PRODUCT_CARD_MARGIN = 24
const REDUCED_PRODUCT_CARD_MARGIN = 16
const TABLET_BREAKPOINT = 927
const DESKTOP_SMALL_BREAKPOINT = 1343

class ProductSearchBar extends React.Component {
  componentDidMount() {
    window.addEventListener('resize', this.calculateDropdownWidth)
    this.calculateDropdownWidth()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.calculateDropdownWidth)
  }

  containerElm = null
  sortElm = null

  updateSaleFilter = () => {
    this.props.history.push(
      this.props.buildUrl({ onSale: !this.props.filterState.onSale })
    )
  }

  containerRef = elm => {
    this.containerElm = elm
  }

  sortRef = elm => {
    this.sortElm = elm
  }

  calculateDropdownWidth = () => {
    if (!this.containerElm || !this.sortElm || !this.sortElm.style) {
      return
    }
    if (window.innerWidth < TABLET_BREAKPOINT) {
      this.sortElm.style.width = '100%'
    } else {
      const margin =
        window.innerWidth < DESKTOP_SMALL_BREAKPOINT
          ? REDUCED_PRODUCT_CARD_MARGIN
          : FULL_PRODUCT_CARD_MARGIN
      const width =
        (this.containerElm.offsetWidth -
          (NUMBER_OF_PRODUCT_CARDS - 1) * margin) /
        NUMBER_OF_PRODUCT_CARDS
      this.sortElm.style.width = `${width}px`
    }
  }

  render() {
    const {
      filterState,
      buildUrl,
      history,
      mobileFilterOpen,
      filterClick,
      showSaleFilter,
    } = this.props

    return (
      <div className={style.productsRefineSort} ref={this.containerRef}>
        <div className={style.productsRefineSortLeft}>
          <Button
            className={classNames(style.filterButton, {
              [style.open]: mobileFilterOpen,
            })}
            onClick={filterClick}
          >
            Filter
          </Button>
        </div>
        <div className={style.productsRefineSortRight}>
          <Checkbox
            checked={filterState.onSale}
            label="Sale items only"
            classNames={{
              wrapper: style.saleCheckboxWrap,
              label: style.saleCheckboxLabel,
            }}
            disabled={!showSaleFilter}
            onChange={this.updateSaleFilter}
          />
          <div className={style.sortWrapper} ref={this.sortRef}>
            <SortDropdown
              sort={filterState.sort}
              history={history}
              buildUrl={update => buildUrl(update)}
              className={style.sortDropdown}
            />
          </div>
        </div>
      </div>
    )
  }
}

ProductSearchBar.propTypes = {
  filterState: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  buildUrl: PropTypes.func.isRequired,
  mobileFilterOpen: PropTypes.bool,
  filterClick: PropTypes.func.isRequired,
  showSaleFilter: PropTypes.bool.isRequired,
}

export default ProductSearchBar
